//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import debounce from 'lodash/debounce';
import { mapState } from 'vuex';
import featureFlagMixin from '@motionelements/core/src/components/mixins/feature-flag.mixin.js';
import { isMobile as detectMobileDevice } from '@motionelements/core/src/helpers/browser.js';
import { faPlay } from '@fortawesome/pro-solid-svg-icons';

export default {
  name: 'player-video',
  mixins: [featureFlagMixin],
  inject: {
    isPopUp: {
      default: false,
    },
  },
  props: {
    element: Object,
    settings: {
      type: Object,
      default: null,
    },
    settingsPlayer: null,
  },
  data() {
    return {
      faPlay,
      nativePreviewPlaying: false,
      nativePreviewVideoEl: null,
    };
  },
  computed: {
    ...mapState({
      isMobile: state => state.browser.isMobile,
    }),
    posterUrl() {
      return _.get(this.element, 'thumbnails.jpg.url')
        || _.get(this.element, 'previews.jpg.url')
        || '';
    },
    showMobileSplash() {
      return this.shouldPrimeMobilePreview && !this.nativePreviewPlaying;
    },
    playerContainerStyle() {
      if (this.useNativeVideoPreview && this.shouldAutoplayPreview) {
        return null;
      }
      if (!this.posterUrl) {
        return null;
      }
      return {
        backgroundImage: `url(${this.posterUrl})`,
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      };
    },
    useNativeVideoPreview() {
      return this.isFeatureEnabled('product_preview_native_video') && !this.settings;
    },
    isMobileDevice() {
      return this.isMobile ?? detectMobileDevice();
    },
    shouldAutoplayPreview() {
      return this.isPopUp && this.useNativeVideoPreview && !this.isMobileDevice;
    },
    shouldPrimeMobilePreview() {
      return this.isPopUp && this.useNativeVideoPreview && this.isMobileDevice;
    },
    playerRootClass() {
      if (this.useNativeVideoPreview) {
        return [
          'product-player-video',
          'product-player-video--native',
          { 'product-player-video--with-controls': this.shouldAutoplayPreview },
          { 'product-player-video--mobile-splash': this.showMobileSplash },
        ];
      }
      return [
        'fp-slim',
        'is-splash',
        'flowplayer',
      ];
    },
    loop() {
      if (this.settings && this.settings.loop === 'none') {
        return false;
      }
      return true;
    },
    speed() {
      if (this.settings && this.settings.speed) {
        return this.settings.speed;
      }
      return 1;
    },
    cuepoints() {
      if (this.settings && this.settings.markers) {
        return this.settings.markers;
      }
      return [];
    },
    settingsFilter() {
      return {
        loop: this.loop,
        autoplay: true, // default value true
        speed: this.speed,
        cuepoints: this.cuepoints,
      };
    },
  },
  watch: {
    // 'settings.loop': function () {
    //   console.log('[PlayerVideo] settings loop update');
    //   // this.unloadVideoPlayer();
    //   // this.initVideoPlayer();
    //   this.$videoPlayerSettings.shutdown();
    //   this.initVideoPlayerSettings();
    // },
    'element.id': function (id, oldId) {
      if (!id || !oldId || id === oldId || this.settings) {
        return;
      }
      this.nativePreviewPlaying = false;
      this.restartPreviewForElementChange();
    },
    'settings.speed': function () {
      console.log('[PlayerVideo] settings speed update');
      // this.unloadVideoPlayer();
      this.changeVideoPlayerSpeed();
      // this.initVideoPlayer();
    },
    'settings.markers': function () {
      console.log('settings markers update');
      // this.$videoPlayer.setCuePoints(...this.settings.markers);
      // this.shutdownVideoPlayer();
      this.shutdownVideoPlayerSettings();
      this.initVideoPlayerSettings();
    },
    // 'settings.autoplay': function () {
    //   console.log('settings autoplay update');
    //   this.unloadVideoPlayer();
    //   this.$videoPlayer.autoplay(true);
    //   this.initVideoPlayer();
    // },
  },
  mounted() {
    // split normal video player and need change settings, ex: gif-creator
    if (this.settings) {
      this.initVideoPlayerSettings();
    } else {
      this.initVideoPlayer();
    }
  },
  beforeDestroy() {
    this.unbindNativePreviewVideoEvents();
    if (this.settings) {
      this.shutdownVideoPlayerSettings();
    } else if (this.useNativeVideoPreview) {
      this.shutdownVideoPlayer();
    } else {
      this.unloadVideoPlayer();
    }
  },
  methods: {
    unloadVideoPlayer() {
      this.$videoPlayer.unload();
    },
    shutdownVideoPlayer() {
      this.$videoPlayer.shutdown();
    },
    shutdownVideoPlayerSettings() {
      this.$videoPlayerSettings.shutdown();
    },
    initVideoPlayer() {
      this.$videoPlayer.init(this.$refs.videoPlayer, this.element, {
        autoplay: this.shouldAutoplayPreview,
        controls: this.shouldAutoplayPreview,
        preferThumbnailSource: false,
      });
      this.$nextTick(() => this.bindNativePreviewVideoEvents());
    },
    bindNativePreviewVideoEvents() {
      this.unbindNativePreviewVideoEvents();
      const video = this.$refs.videoPlayer?.querySelector?.('video');
      if (!video) {
        return;
      }
      this.nativePreviewVideoEl = video;
      video.addEventListener('playing', this.onNativePreviewPlaying);
      video.addEventListener('pause', this.onNativePreviewPause);
    },
    unbindNativePreviewVideoEvents() {
      const video = this.nativePreviewVideoEl;
      if (!video) {
        return;
      }
      video.removeEventListener('playing', this.onNativePreviewPlaying);
      video.removeEventListener('pause', this.onNativePreviewPause);
      this.nativePreviewVideoEl = null;
    },
    onNativePreviewPlaying() {
      this.nativePreviewPlaying = true;
    },
    onNativePreviewPause() {
      const video = this.nativePreviewVideoEl;
      if (video && !video.paused) {
        return;
      }
      this.nativePreviewPlaying = false;
      if (this.shouldPrimeMobilePreview) {
        this.$videoPlayer.unload();
      }
    },
    playMobilePreview() {
      this.$videoPlayer.play();
    },
    restartPreviewForElementChange() {
      this.shutdownVideoPlayer();
      this.initVideoPlayer();
      if (this.shouldAutoplayPreview) {
        this.$videoPlayer.play();
      }
    },
    initVideoPlayerSettings: debounce(function () {
      // console.log('[PlayerVideo] init player settings: ', this.settingsFilter);
      if (this.settings) {
        this.$videoPlayerSettings.updateSettings(this.settingsFilter);
      }
      // init video player
      this.$videoPlayerSettings.init(this.$refs.videoPlayer, this.element);
      // this.changeVideoPlayerSpeed();
      // console.log('videoplayer settings: ', this.$videoPlayer);
      // console.log('videoplayer settings: ', this.settings);
    }, 0),
    changeVideoPlayerSpeed() {
      // console.log('[PlayerVideo] change video player speed');
      if (this.settings && this.settings.speed) {
        // console.log('[PlayerVideo] change video player speed: ', this.settings.speed);
        this.$videoPlayerSettings.speed(this.settings.speed);
      } else {
        // console.log('[PlayerVideo] change video player speed: 1');
        this.$videoPlayerSettings.speed(1);
      }
    },
    // changeVideoPlayerLoop() {
    //   console.log('[PlayerVideo] change video player loop: ', this.loop);
    //   this.$videoPlayer.loop(this.loop);
    //   // if (this.settings.loop === 'none') {
    //   // } else {
    //   //   this.$videoPlayer.loop(true);
    //   // }
    // },
  },
};
